<template>
    <div class="timeline-block" v-if="!edition_state" @mouseover="show_actions = true" @mouseleave="show_actions = false" >
      <div class="timeline-point success">
        <i class="pg-phone" v-if="interaction.type == 'phone_call'"></i>
        <i class="fa fa-file" v-else-if="interaction.type == 'document_sending'"></i>
        <i class="pg-mail" v-else-if="interaction.type == 'email'"></i>
        <i class="fa fa-exchange" v-else></i>
      </div>
      <div class="timeline-content">
        <div class="card social-card share full-width">
          <div class="card-header clearfix" style="display:flex;height:70px;">
            <div>
              <h5>{{interaction.decoded_type}} <span v-if="interaction.type == 'document_sending' && interaction.document_sending_type"> d'une {{interaction.decoded_document_sending_type}}</span><span v-if="interaction.type == 'other'"> : {{interaction.other_type}}</span>
                  <span v-if="interaction.scheduled_date"> planifié pour le {{interaction.scheduled_date | moment-date}} </span>
                  <br><span v-if="interaction.type == 'document_sending'"> à {{interaction.document_sending_email}}</span>
                  <span v-if="interaction.type == 'document_sending' && interaction.document_sending_name"> par {{interaction.document_sending_name}}</span>
                </h5>
              <h6 v-if="interaction.scheduled_date">
                  Créée le {{interaction.created_at | moment-date}} <span v-if="interaction.user"> par {{ interaction.user.email }}</span>
              </h6>
              <h6 v-if="interaction.status === 'done'">
                  Réalisée le {{interaction.interaction_date | moment-date}} <span v-if="interaction.user"> par {{ interaction.user.email }}</span>
              </h6>

            </div>
            <div style="display:flex;margin-left:auto;">
              <button class="btn btn-success" style="height:37px;" @click="edition_state = true" v-if="show_actions">
                <i class="fa fa-edit"></i>
                Editer
              </button>
              <button class="btn" @click="remove_interaction" style="height:37px;" v-if="check_access && !interaction.protected && show_actions">
                <i class="pg-trash"></i>
              </button>

            </div>
          </div>
          <div class="card-description">
            <p>{{interaction.message}}</p>
            <button class="btn btn-default" :disabled="true" v-if="interaction.scheduled_date && interaction.status === 'done'">
              <span ><i class="fa fa-check-circle" style="green"></i>Réalisée</span>
            </button>
            <!-- <p v-if="interaction.type == 'document_sending'">Liste des documents envoyés:
              <br v-if="interaction_files.length">
              <span v-for="(m, midx) in interaction_files" :key="'media-filename-' + midx">
                {{m}}
                <br v-if="midx < interaction_files.length">
              </span>
            </p> -->

            <button class="btn btn-success" style="height:37px;" v-if="interaction.scheduled_date && interaction.status != 'done'" @click="realize_schedule_interaction()">
              <i class="fa fa-check"></i>
              Effectuée
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="timeline-block" v-else>
      <div class="timeline-point success">
        <i class="pg-phone" v-if="interaction.type == 'phone_call'"></i>
        <i class="fa fa-file" v-else-if="interaction.type == 'document_sending'"></i>
        <i class="pg-mail" v-else-if="interaction.type == 'email'"></i>
        <i class="fa fa-exchange" v-else></i>
      </div>
      <div class="timeline-content">
        <div class="card social-card share full-width">
          <div class="card-header clearfix" style="display:flex;">
              <div>
                <h5>{{interaction.decoded_type}} <span v-if="interaction.type == 'document_sending' && interaction.document_sending_type"> d'une {{interaction.decoded_document_sending_type}}</span><span v-if="interaction.type == 'other'"> : {{interaction.other_type}}</span>
                    <span v-if="interaction.scheduled_date"> planifié pour le {{interaction.scheduled_date | moment-date}} </span>
                    <br><span v-if="interaction.type == 'document_sending'"> à {{interaction.document_sending_email}}</span>
                    <span v-if="interaction.type == 'document_sending' && interaction.document_sending_name"> par {{interaction.document_sending_name}}</span>
                  </h5>
                <h6>
                    Créée le {{interaction.interaction_date | moment-date}} <span v-if="interaction.user"> par {{ interaction.user.email }}</span>
                </h6>
              </div>
              <div style="margin-left:auto;">
                <button class="btn btn-success" @click="edit_interaction">
                  <i class="fa fa-checked"></i>
                  Valider
                </button>
                <button class="btn" @click="reset_fields">
                  <!-- <i class="fa fa-refresh"></i> -->
                  Annuler
                </button>
              </div>
          </div>
          <div class="card-description">
            <div class="row">

              <div class="form-group tip col-lg-6" v-if="selected_type == 'other'">
                <label>Autre type</label>
                <input type="text" class="tip form-control" v-model="selected_other_type" :disabled="is_fetching"></input>
              </div>
              <div class="form-group tip col-lg-6" v-if="interaction.scheduled_date != null && interaction.status=='scheduled'">
                <label>Date de rappel</label>
                <input type="text" id="edit-date-interact" class="form-control tip date-time-field" v-model="edited_interaction_date" :disabled="is_fetching || interaction.type == 'document_sending'">
                <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label>Commentaire pour votre propre suivi</label>
                <textarea v-model="edited_message" class="form-control tip"> :disabled="is_fetching"</textarea>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex"
import Select2 from "components/Form/Select2"
import Notifications from "../Notifications"

export default {
  name:"CRM_Lead_Timeline_Item",
  props:["interaction"],
  components:{
    Select2,
    Notifications
  },
  data () {
    return {
        edition_state:false,
        available_options_types:[
          {
            id:"phone_call",
            text:"Appel téléphonique"
          },
          {
            id:"email",
            text:"E-mail"
          },
          {
            id:"document_sending",
            text:"Envoi de documents"
          },
          {
            id:"other",
            text:"Autre"
          }
        ],
        selected_type:this.interaction.type,
        selected_other_type:this.interaction.other_type,
        edited_message:this.interaction.message,
        edited_interaction_date:moment(this.interaction.scheduled_date).format("YYYY-MM-DD"),
        edited_document_sending_email:this.interaction.document_sending_email,
        show_actions:false,
        base_path:__API_URL__,
        available_doctypes:[
          {id:"domiciliation_offer", text:'Offre commerciale domiciliation'},
          {id:'office_offer', text:'Offre bureaux longue durée'},
          {id:'punctual_booking_offer', text:'Offre bureaux courte durée'}
        ],
    }
  },
  computed:{
    ...mapState("crm", "users"),
    ...mapGetters("crm", ["is_fetching","is_any_errors","errors"]),
    ...mapState(["agencies", "user"]),

    interaction_files()
    {
      return _.filter(_.split(this.interaction.document_sending_files, '\n'), f => f.length > 0)
    },

    check_access()
    {
      var res = false
      if (this.user && this.user.me)
        _.each(this.user.me.roles, (role) => {
          if (role.name == 'green-number' || role.name == 'manager' || role.name == 'administrator' || role.name == 'super-administrator')
            res = true
        })
      return res
    },
  },
  methods:{
    ...mapActions("crm", ["destroy_interaction","set_fetching_state","fetch_interactions","update_interaction","reset_error","get_user_info","update_scheduled_interaction","realize_interaction","fetch_a_lead","fetch_all_leads"]),

    remove_interaction() {
      this.$emit('remove-interaction', {lead_id:this.interaction.lead_id, lead_interaction_id:this.interaction.id, data:this.interaction})
    },

    get_email_of(cid){
      var found = _.find(this.users, u => {
        return u.id === cid
      })
      return found != undefined ? found.email : null
    },

    edit_interaction() {
      var p = null
      if (this.interaction.scheduled_date == null)
        p = this.update_interaction({lead_id:this.interaction.lead_id, lead_interaction_id:this.interaction.id, params:{
          type:this.selected_type,
          other_type:this.selected_other_type,
          message:this.edited_message,
          document_sending_email:this.edited_document_sending_email,
          interaction_date:moment(this.interaction.interaction_date).format("YYYY-MM-DD HH:mm:ss")
        }})
      else {
        p = this.update_scheduled_interaction({
          lead_id:this.interaction.lead_id,
          lead_interaction_id:this.interaction.id,
          params:{
            type:this.selected_type,
            other_type:this.selected_other_type,
            message:this.edited_message,
            document_sending_email:this.edited_document_sending_email,
            interaction_date:moment(this.interaction.interaction_date).format("YYYY-MM-DD HH:mm:ss"),
            scheduled_date:moment(this.edited_interaction_date).format("YYYY-MM-DD HH:mm:ss")
          }
        })
      }
      p.then(() => {
        this.set_fetching_state(true)
        this.fetch_a_lead(this.interaction.lead_id)
            .then(() => this.set_fetching_state(false))
            .then(() => this.reset_fields())
      })
    },

    realize_schedule_interaction() {
      this.realize_interaction({
        lead_id:this.interaction.lead_id,
        lead_interaction_id:this.interaction.id,
        params:{
          message:this.interaction.message,
          document_sending_email:this.interaction.document_sending_email
        }
      })
      .then(() => {
        this.set_fetching_state(true)
        this.fetch_a_lead(this.interaction.lead_id)
            .then(() => this.fetch_all_leads())
            .then(() => this.set_fetching_state(false))
            .then(() => this.reset_fields())
            .then(() => this.$emit('scheduled-interaction-realized', {lead_interaction_id:this.interaction.id}))
      })
    },

    reset_fields() {
      this.selected_type=this.interaction.type
      this.selected_other_type=this.interaction.other_type
      this.edited_message=this.interaction.message
      this.edited_document_sending_email=this.interaction.document_sending_email
      this.edited_interaction_date=moment(this.interaction.scheduled_date).format("YYYY-MM-DD")
      this.edition_state=false
    },

    showCartFooter(){
      this.show_actions = !this.show_actions
    },

    str_of_doc_type(t)
    {
      let found = _.find(this.available_doctypes, ad => ad.id === t)
      return found != undefined ? found.text : ""
    }
  },

  watch : {
    edition_state : function () {
      this.$nextTick()
          .then(() => {
              $('#edit-date-interact', this.$el).datepicker({
                  format: "yyyy-mm-dd",
                  language: "fr",
                  autoclose: true,
                  title: "Date d'interaction",
              }).on('changeDate', (e) => {
                  this.edited_interaction_date = e.target.value
              })
            })
      }
  },

  created() {
  }
}
</script>
<style scoped>
.interaction-container {
  display: flex;
}

.interaction-head-container {

}

.interaction-container-right {
  margin-left: auto;
}
.interaction-container-left {


}

.marged-top {
  margin-top: 15px;
}

.interaction-container-edition {
  /*display: flex;*/
  height:220px;
}

.interaction-container-top-edition {
}
.interaction-container-bottom-edition {

}
</style>



// WEBPACK FOOTER //
// client/components/CRM/Interactions/TimelineItem.vue